import apiClient from 'helpers/api-client'
import { StateCreator } from 'zustand'
import {
  IPayloadInquiry,
  IPayloadWithdraw,
  IWithdrawal,
} from './interface'
import { sendLog } from 'helpers/log'

export const createWithdrawalSlice: StateCreator<IWithdrawal> = (
  set,
) => ({
  // state
  withdrawStatus: {
    withdraw_date: '',
    requested_amount: 0,
    withdraw_fee: 0,
    received_amount: 0,
    status: 'PENDING',
    label: {
      title: '',
      message: '',
    },
    requested_by: '',
    approved_by: '',
  },
  errorMsgInquiry: '',

  // actions
  requestInquiry: async (payload: IPayloadInquiry) => {
    try {
      const res = await apiClient.post(
        '/wallet/hub/v1/income/withdraw/inquiry',
        {
          amount: payload.amount,
        },
      )
      return res?.data
    } catch (error) {
      sendLog(`Error: ${error?.code} - ${error?.message}`)
      throw error
    }
  },

  requestWithdraw: async (payload: IPayloadWithdraw) => {
    try {
      apiClient.defaults.headers.common['Idempotent-Key'] =
        payload?.idempotentKey
      const res = await apiClient.post(
        '/wallet/hub/v1/income/withdraw',
        {
          amount: payload.amount,
        },
      )
      return res?.data
    } catch (error) {
      sendLog(`Error: ${error?.code} - ${error?.message}`)
      throw error
    }
  },
  getWithdrawStatus: async () => {
    try {
      const res = await apiClient.get(
        '/wallet/hub/v1/income/withdraw/status',
      )
      if (res?.data?.code === 'SUCCESS') {
        set({
          withdrawStatus: res?.data?.data,
        })
      }
    } catch (error) {
      console.error(error)
    }
  },
})
